export const routes = {
    "/:taskId/mhpTreatmentConsultation": {
        title: "MHP Treatment Consultation"
    },
    "/:taskId/mhpTreatmentReport": {
        title: "MHP Treatment Report"
    },
    "/:taskId/previewMHPTreatmentReport": {
        title: "Preview MHP Treatment Report"
    },
    "/:taskId/amendMHPTreatmentReport": {
        title: "MHP Treatment Report"
    },
    "/:taskId/qaAmendMHPTreatmentReport": {
        title: "MHP Treatment Report"
    }
};
